import {
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

interface CreateIndividualLinkRequest {
  fileId: number;
  email: string;
}

export const createIndividualLink = ({
  fileId,
  email,
}: CreateIndividualLinkRequest) => {
  return api.post<ApiResponse>('/v2/file/individual', {
    fileId,
    email,
  });
};

const useCreateIndividualLink = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse>,
    TError,
    CreateIndividualLinkRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse>,
  TError,
  CreateIndividualLinkRequest,
  QueryKey
> => {
  return useMutation(createIndividualLink, {
    ...options,
  });
};

export default useCreateIndividualLink;
